import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'fa-global-navbar',
  templateUrl: './global-navbar.component.html',
  styleUrls: ['./global-navbar.component.scss']
})
export class GlobalNavbarComponent implements OnInit {

  @Input() data:any;

  @Input() type: string = 'homepage';
  @Input() activeTab: string = 'overview';
  @Input() codeExpiry: number = 0;
  @Input() isPartnerLink: boolean = false;
  @Input() partnerLogo: string = '';
  @Input() testTitle: string = '';
  @Input() puid: string = '';
  @Input() visamonkPermissions: any = {};



  @Output() tabChanged = new EventEmitter<string>();
  @Output() loginClicked = new EventEmitter<string>();
  @Output() getStartedClicked = new EventEmitter<string>();
  @Output() logoutClicked = new EventEmitter<boolean>();
  @Output() backClicked = new EventEmitter<void>();
  @Output() helpClicked = new EventEmitter<void>();
  @Output() partnerSigninClicked = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  onTabClick(tabId: string) {
    this.tabChanged.emit(tabId);
  }

  onLogin() {
    this.loginClicked.emit('login');
  }

  onGetStarted() {
    this.getStartedClicked.emit('signup');
  }

  onLogout() {
    this.logoutClicked.emit(true);
  }

  onBack() {
    this.backClicked.emit();
  }

  onHelp() {
    this.helpClicked.emit();
  }

  onPartnerSignin() {
    this.partnerSigninClicked.emit(true);
  }

}
